import { Icon } from "PFComponents/icon";
import { IconName } from "PFTheme/graphics/icons";
import React from "react";

import { MarketplaceNavigationButton } from "../../../components";
import css from "./tile_button.module.scss";

export type TileButtonProps = {
  onClick: () => void;
  iconName?: IconName;
};

export const TileButton = ({ onClick, iconName, children }: React.PropsWithChildren<TileButtonProps>) => (
  <MarketplaceNavigationButton onClick={onClick}>
    <div className={css.wrapper}>
      <div className={css.content}>
        {iconName && <Icon name={iconName} color="paletteWhite0" size="sm" />}
        {children!}
      </div>
      <Icon name="chevron-right" color="paletteWhite0" size="sm" />
    </div>
  </MarketplaceNavigationButton>
);
